import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import {formatAvailabilityId} from 'utils/formatAvailabilityId'

export const MinimizedAvailanility = () => {
  const availabilityId = InputProvider.useAvailabilityId('optional')
  return <div>{availabilityId ? formatAvailabilityId(availabilityId) : null}</div>
}
